import React from "react";
import { Modal, Icon } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import _ from "i18n";

const FilterModal = ({
  visible,
  budgetManagement,
  handleDontSaveClick,
  handleSaveClick,
  handleCancelClick
}) => {

  return (
    <Modal
      visible={visible}
      title={null}
      closable={false}
      footer={null}
    >
      <div className={'px-3 py-3'}>
        <div className={'flex items-start'}>
          <ExclamationCircleOutlined className={'flex mr-2'} style={{
            color: '#FFD700',
            fontSize: '20px'
          }} />
          {_('CHANGE_FILTER_WITHOUT_SAVING')}
        </div>
        <div className={'flex justify-around '}>
          <button key="back" className={'cancel'}
            onClick={handleCancelClick}>
            {_('cancel')}
          </button>
          <button key="quit" className={'notSave'}
            onClick={handleDontSaveClick}>
            {_('QUIT')}
          </button>
          <button key="submit" className={'save'}
            onClick={handleSaveClick}>
            {_('save')}
            {budgetManagement.generateFollowUp.processing === true &&
              <Icon className="ml-2" type="sync" spin />}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default FilterModal;



// WEBPACK FOOTER //
// ./app/components/common/BudgetManagement/FilterModal.js